module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/business-calculator/site/site.component.html
// module id = ./src/app/components/calculator/calculator-item/business-calculator/site/site.component.html
// module chunks = main